module.exports = __webpack_public_path__ + "img/company8.6a7b3fe2.png";